import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
    ArrayField,
    SingleFieldList,
    ChipField,
} from "react-admin";
export const RoleShow = (props) => (
  <Show title="Role Details" {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <TextField source="is_active" />
      <TextField source="created_at" />
      <TextField source="created_by" />

      {/* 🔥 Show Permissions */}
      <ArrayField source="permissions">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
